/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import Button from 'app/components/commons/Button';
import Responsive from 'app/components/responsive/Responsive';
import VerificationSummaryText from 'app/components/user/VerificationSummaryText';
import t from 'app/utils/translate';

type Status = 'done' | 'not done' | 'pending';

type Props = {
  emailVerificationStatus: Status,
  enableMobileVerification: boolean,
  identityVerificationStatus: Status,
  phoneVerificationStatus: Status,
  profileCompletionStatus: Status
};

const List = styled.ul(({ theme }) => ({
  alignItems: 'stretch',
  display: 'flex',
  fontSize: '0.8rem',
  listStyle: 'none',
  margin: 0,
  padding: 0,
  [theme.mediaQuery.desktopAndUp]: {
    display: 'block'
  }
}));

const Item = styled.li(({ theme }) => ({
  alignItems: 'stretch',
  display: 'flex',
  flexBasis: 0,
  flexGrow: 1,
  flexShrink: 1,
  justifyContent: 'center',
  paddingTop: 1,
  paddingBottom: 1,
  [theme.mediaQuery.desktopAndUp]: {
    justifyContent: 'flex-start'
  },
  '&:not(:first-of-type)': {
    borderLeftColor: theme.color.invertableBasis5,
    borderLeftStyle: 'solid',
    borderLeftWidth: 1,
    [theme.mediaQuery.desktopAndUp]: {
      borderLeftWidth: 0
    }
  }
}));

const VerificationSummary: React.FC = ({
  emailVerificationStatus,
  enableMobileVerification,
  identityVerificationStatus,
  phoneVerificationStatus,
  profileCompletionStatus
}: Props) => {
  return (
    <List>
      <Item>
        <VerificationSummaryText status={emailVerificationStatus}>
          {t('Verify Email')}
        </VerificationSummaryText>
      </Item>
      {enableMobileVerification && (
        <Item>
          <VerificationSummaryText status={phoneVerificationStatus}>
            {t('Verify Mobile')}
          </VerificationSummaryText>
        </Item>
      )}
      <Item>
        <VerificationSummaryText status={profileCompletionStatus}>
          {t('Complete Profile')}
        </VerificationSummaryText>
      </Item>
      <Responsive desktop>
        {isDesktop => (
          <Item>
            {isDesktop || identityVerificationStatus !== 'not done' ? (
              <VerificationSummaryText status={identityVerificationStatus}>
                {t('Verify ID')}
              </VerificationSummaryText>
            ) : (
              <Button
                disabled={profileCompletionStatus === 'not done'}
                link={{ search: '?modal=verify-id' }}
              >
                {t('Verify ID')}
              </Button>
            )}
          </Item>
        )}
      </Responsive>
    </List>
  );
};

export default VerificationSummary;
